var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from '@web/theme';
import React, { memo } from 'react';
import { contrast } from '@web/utils';
export var ColorPreview = memo(function (_a) {
    var id = _a.id, color = _a.color, onClick = _a.onClick, blockBg = _a.blockBg;
    var _onClick = function () { return onClick(id); };
    return (React.createElement(Wrapper, { onClick: _onClick },
        React.createElement(Border, { onClick: _onClick, style: { borderColor: contrast(blockBg) } },
            React.createElement(Preview, { style: { backgroundColor: color } }))));
});
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-right: .2em;\n"], ["\n\tmargin-right: .2em;\n"])));
var Border = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tborder: 3px solid transparent};\n\tmargin-left: .2em;\n\t\n\t&:not(:last-child) {\n\t\tmargin-right: .2em;\n\t}\n"], ["\n\tborder: 3px solid transparent};\n\tmargin-left: .2em;\n\t\n\t&:not(:last-child) {\n\t\tmargin-right: .2em;\n\t}\n"])));
var Preview = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 15px;\n\theight: 15px;\n"], ["\n\twidth: 15px;\n\theight: 15px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
